'use client';

import { c as _c } from "react/compiler-runtime";
import type { CreateOrderActions, CreateOrderData, CreateSubscriptionActions, OnApproveActions, OnApproveData } from '@paypal/paypal-js';
import { DISPATCH_ACTION, PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js';
import { useEffect } from 'react';
type PaymentPaypalButtonsProps = {
  paymentAmount: number;
  paymentRecurring: boolean;
  paymentType: string;
  paymentSubmitting: boolean;
  paymentAcceptTerms: boolean;
  paypalCreateOrder: () => Promise<string>;
  paypalOnApprove: (data: OnApproveData) => Promise<void>;
  paypalCreateSubscription: () => Promise<string>;
  paypalOnApproveSubscription: (data: OnApproveData) => Promise<void>;
  paypalOnError: () => void;
  isFree: boolean;
};
export function PaymentPaypalButtons(t0) {
  const $ = _c(38);
  const {
    paymentAmount,
    paymentRecurring,
    paymentType,
    paymentSubmitting,
    paymentAcceptTerms,
    paypalCreateOrder,
    paypalOnApprove,
    paypalCreateSubscription,
    paypalOnApproveSubscription,
    paypalOnError,
    isFree
  } = t0;
  const [t1, dispatch] = usePayPalScriptReducer();
  const {
    options
  } = t1;
  let t2;
  if ($[0] !== dispatch || $[1] !== options || $[2] !== paymentRecurring) {
    t2 = () => {
      dispatch({
        type: DISPATCH_ACTION.RESET_OPTIONS,
        value: {
          ...options,
          intent: paymentRecurring ? "subscription" : "capture",
          vault: paymentRecurring
        }
      });
    };
    $[0] = dispatch;
    $[1] = options;
    $[2] = paymentRecurring;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isFree || $[5] !== paymentRecurring) {
    t3 = [paymentRecurring, isFree];
    $[4] = isFree;
    $[5] = paymentRecurring;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== paypalCreateOrder) {
    t4 = async (_data, _actions) => await paypalCreateOrder();
    $[7] = paypalCreateOrder;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleCreateOrder = t4;
  let t5;
  if ($[9] !== paypalOnApprove) {
    t5 = async (data, _actions_0) => {
      await paypalOnApprove(data);
    };
    $[9] = paypalOnApprove;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleOnApprove = t5;
  let t6;
  if ($[11] !== paypalCreateSubscription) {
    t6 = async (_data_0, _actions_1) => await paypalCreateSubscription();
    $[11] = paypalCreateSubscription;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleCreateSubscription = t6;
  let t7;
  if ($[13] !== paypalOnApproveSubscription) {
    t7 = async (data_0, _actions_2) => {
      await paypalOnApproveSubscription(data_0);
    };
    $[13] = paypalOnApproveSubscription;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const handleOnApproveSubscription = t7;
  let t8;
  if ($[15] !== handleCreateSubscription || $[16] !== handleOnApproveSubscription || $[17] !== isFree || $[18] !== paymentAcceptTerms || $[19] !== paymentAmount || $[20] !== paymentRecurring || $[21] !== paymentSubmitting || $[22] !== paymentType || $[23] !== paypalOnError) {
    t8 = paymentRecurring && paymentType === "paypal" && !isFree && <PayPalButtons fundingSource="paypal" createSubscription={handleCreateSubscription} onApprove={handleOnApproveSubscription} onError={paypalOnError} disabled={paymentSubmitting || !paymentAcceptTerms} forceReRender={[paymentAmount, paymentRecurring, paymentType]} style={{
      shape: "sharp",
      disableMaxWidth: true,
      color: "gold"
    }} />;
    $[15] = handleCreateSubscription;
    $[16] = handleOnApproveSubscription;
    $[17] = isFree;
    $[18] = paymentAcceptTerms;
    $[19] = paymentAmount;
    $[20] = paymentRecurring;
    $[21] = paymentSubmitting;
    $[22] = paymentType;
    $[23] = paypalOnError;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== handleCreateOrder || $[26] !== handleOnApprove || $[27] !== isFree || $[28] !== paymentAcceptTerms || $[29] !== paymentAmount || $[30] !== paymentRecurring || $[31] !== paymentSubmitting || $[32] !== paymentType || $[33] !== paypalOnError) {
    t9 = !paymentRecurring && paymentType === "paypal" && !isFree && <PayPalButtons fundingSource="paypal" createOrder={handleCreateOrder} onApprove={handleOnApprove} onError={paypalOnError} disabled={paymentSubmitting || !paymentAcceptTerms} forceReRender={[paymentAmount, paymentRecurring, paymentType]} style={{
      shape: "sharp",
      disableMaxWidth: true,
      color: "gold"
    }} />;
    $[25] = handleCreateOrder;
    $[26] = handleOnApprove;
    $[27] = isFree;
    $[28] = paymentAcceptTerms;
    $[29] = paymentAmount;
    $[30] = paymentRecurring;
    $[31] = paymentSubmitting;
    $[32] = paymentType;
    $[33] = paypalOnError;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== t8 || $[36] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[35] = t8;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  return t10;
}